// Layout: resizable chat/document panels (used in HomePageV2 and styles)
export const MIN_PANEL_WIDTH_PX = 500;
export const MAX_CHAT_WIDTH_PX = 1200;
export const DEFAULT_CHAT_WIDTH_PX = 500;

// Tag-related constants and utilities
export const MAX_VISIBLE_TAGS = 6;

export const TAG_COLORS = ["limeGreen", "yellow", "purple", "lightBlue"];

/**
 * Calculates which tags should be visible and which should be hidden
 * @param {string[]} tags - Array of tag strings
 * @returns {Object} Object with visibleTags, hiddenTagsCount, and hiddenTags
 */
export const calculateVisibleTags = (tags) => {
  if (tags.length <= MAX_VISIBLE_TAGS) {
    return {
      visibleTags: tags,
      hiddenTagsCount: 0,
      hiddenTags: [],
    };
  }

  return {
    visibleTags: tags.slice(0, MAX_VISIBLE_TAGS),
    hiddenTagsCount: tags.length - MAX_VISIBLE_TAGS,
    hiddenTags: tags.slice(MAX_VISIBLE_TAGS),
  };
};

/**
 * Checks if a tag already exists in the tags array (case-insensitive)
 * @param {string} newTag - The tag to check
 * @param {string[]} existingTags - Array of existing tags
 * @returns {boolean} True if tag already exists
 */
export const tagExists = (newTag, existingTags) => {
  const trimmedTag = newTag.trim().toLowerCase();
  return existingTags.some(tag => tag.toLowerCase() === trimmedTag);
};

/**
 * Formats hidden tags for tooltip display
 * @param {string[]} hiddenTags - Array of hidden tag strings
 * @returns {string} Comma-separated string of tags
 */
export const formatTagsForTooltip = (hiddenTags) => {
  return hiddenTags.length > 0 ? hiddenTags.join(", ") : "";
};

/**
 * Gets the tag color based on index (rotates through available colors)
 * @param {number} index - Index of the tag
 * @param {string[]} colors - Array of available color names
 * @returns {string} Color name
 */
export const getTagColor = (index, colors) => {
  return colors[index % colors.length];
};

/**
 * Finds the actual input element inside a TextField wrapper
 * @param {HTMLElement} wrapper - The wrapper element containing the TextField
 * @returns {HTMLElement|null} The input element or null if not found
 */
export const findInputElement = (wrapper) => {
  if (!wrapper) return null;
  
  return wrapper.querySelector('input') || 
         wrapper.querySelector('textarea') ||
         wrapper.querySelector('[role="textbox"]') ||
         null;
};
